"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTemplate = exports.formatWithCommas = exports.isDecimalString = exports.isNumericString = void 0;
// 数値文字列かどうかの判定
const isNumericString = (value) => {
    return !isNaN(Number(value));
};
exports.isNumericString = isNumericString;
// 小数を含む数値文字列かどうかの判定
const isDecimalString = (value) => {
    return (0, exports.isNumericString)(value) && /^-?\d*\.\d+/.test(value);
};
exports.isDecimalString = isDecimalString;
// 数値文字列をカンマ区切りにする
const formatWithCommas = (value, decimal) => {
    const parsedNumber = typeof value === "string" ? parseFloat(value) : value;
    if (!value || isNaN(parsedNumber)) {
        return value;
    }
    const decimalPlaces = decimal !== undefined && isNaN(decimal) ? undefined : decimal;
    return parsedNumber.toLocaleString("en-US", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    });
};
exports.formatWithCommas = formatWithCommas;
// テンプレートにパラメータを適用する
// テンプレートの書式: {パラメータ名}
const applyTemplate = (template, params) => {
    return template.replace(/{(.*?)}/g, (match, str) => {
        return params[str] || "";
    });
};
exports.applyTemplate = applyTemplate;
